module.exports = __webpack_public_path__ + "img/charger-speeds-mobile-fr.8528de92.webp";